const HEADER_BG = '#151C28';
const HEADER_COLOR = '#ffffff';
const STATUS_ICON_PASS = 'assets/images/virtusa-icons/pass-check.svg';
const STATUS_ICON_FAIL = 'assets/images/virtusa-icons/fail-check.svg';
const STATUS_ICON_STYLE = { width: '18px !important', height: '18px !important' };

export const cicdExecutionsColumns = [
  {
    display_name: '',
    key: 'select',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      width: '50px',
    },
    cellStyles: { width: '50px' },
    _config: {
      type: 'checkbox',
      displayInColumn: false,
      value: 'id',
      isClickable: 'true',
    },
  },
  {
    display_name: 'Execution',
    key: 'name',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
    },
    _config: {
      type: 'double-line-data',
      targetKey: {
        firstLine: 'name',
        secondLine: '',
      },
    },
  },
  {
    display_name: 'Test failure analysis',
    key: 'testFailureAnalysis',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      'text-align': 'center',
    },
    cellStyles: { 'text-align': 'center' },
    _config: {
      type: 'image',
      isConditional: true,
      targetKey: 'testFailureAnalysis',
      value: {
        pass: { value: STATUS_ICON_PASS, style: STATUS_ICON_STYLE },
        fail: { value: STATUS_ICON_FAIL, style: STATUS_ICON_STYLE },
      },
    },
  },
  {
    display_name: 'UI Self-healing',
    key: 'uiSelfHealing',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      'text-align': 'center',
    },
    cellStyles: { 'text-align': 'center' },
    _config: {
      type: 'image',
      isConditional: true,
      targetKey: 'uiSelfHealing',
      value: {
        pass: { value: STATUS_ICON_PASS, style: STATUS_ICON_STYLE },
        fail: { value: STATUS_ICON_FAIL, style: STATUS_ICON_STYLE },
      },
    },
  },
  {
    display_name: 'Release',
    key: 'releaseName',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      'text-align': 'center',
    },
    cellStyles: { 'text-align': 'center' },
    _config: {
      type: 'image_with_text',
      prefixImage: {
        targetKey: 'releaseStatus',
        values: {
          fail: STATUS_ICON_FAIL,
        },
        styles: {
          fail: STATUS_ICON_STYLE,
        },
      },
    },
  },
  {
    display_name: 'CI/CD Config Info',
    key: 'cicdConfigInfo',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      'text-align': 'center',
    },
    cellStyles: { 'text-align': 'center' },
    _config: {
      type: 'link',
      name: 'CI/CD Config Info',
      displayInColumn: false,
    },
  },
  {
    display_name: 'Actions',
    key: 'viewDetails',
    headerStyles: {
      background: HEADER_BG,
      color: HEADER_COLOR,
      padding: '10px 12px',
      'text-align': 'center',
    },
    cellStyles: { 'text-align': 'center' },
    _config: {
      type: 'link',
      name: 'View Details',
      displayInColumn: false,
    },
  },
];
